import { useTranslation } from "react-i18next";
import { useAreas } from "../../hooks/useAreas";
import { AreaTableHeader } from "./AreaTableHeader";
import { AreaTableRow } from "./AreaTableRow";
import { useAreaStore } from "../../store/areaStore";

export const AreaList = () => {
  const { t } = useTranslation();
  const { areas, isLoading } = useAreas();
  const searchQuery = useAreaStore((state) => state.searchQuery);

  const filteredAreas = areas.filter((area) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      area.name.toLowerCase().includes(searchLower) ||
      area.code.toLowerCase().includes(searchLower)
    );
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center py-8">
        <span className="loading loading-spinner loading-lg"></span>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="bg-white rounded-xl overflow-x-auto">
        <table className="table w-full">
          <thead className="hidden md:table-header-group">
            <AreaTableHeader />
          </thead>
          <tbody>
            {filteredAreas.map((area) => (
              <AreaTableRow key={area.code} area={area} />
            ))}
            {filteredAreas.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  {searchQuery
                    ? t("areas.noSearchResults")
                    : t("areas.noAreasYet")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}; 